import { QueryClient } from '@tanstack/react-query';
import { ApiError, AccessLockedError } from '../services/apiClient';

/**
 * Shared React Query client for the authenticated app. Conservative defaults for
 * a SaaS dashboard:
 *  - 30s staleTime to cut redundant refetches while keeping data reasonably fresh;
 *  - one retry on transient failures, but NEVER retry auth (401) or
 *    subscription-lock (403 / AccessLockedError) — retrying those is pointless and
 *    only delays routing the user to sign-in / billing;
 *  - no refetch-on-focus (noisy for a management UI);
 *  - mutations never auto-retry (avoid duplicate writes).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof AccessLockedError) return false;
        if (error instanceof ApiError && [401, 403, 404].includes(error.status)) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
